import React, { useState, useEffect } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

import {
  GetBasicBrandListService,
  GetCurrentBrandService
} from 'services';


export const BrandDropDown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const [currentBrand, setCurrentBrand] = useState([]);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  useEffect(() => {
    GetBasicBrandListService().then((brands) => {
      setBrands(brands ?? []);
    })
    GetCurrentBrandService().then((currentBrand) => {
      setCurrentBrand(currentBrand);
    })
  }, [])

  const redirectAndReload = () => {
    window.location.href = "/whats/#/dashboard";
    document.location.reload(true);
  }

  const alternateBrand = (event) => {
    const idBrandSelected = event.target.name;
    localStorage.setItem('@brand', idBrandSelected);
    redirectAndReload();
  }

  const renderDropDownMenu = () => {
    if (brands.length) {
      return (
        <DropdownMenu>
          {brands.map((i, index) => {
            return <DropdownItem onClick={alternateBrand} name={i?.idBrand} active={i?.idBrand === currentBrand.idBrand} key={index}>{i?.name}</DropdownItem>;
          })}
        </DropdownMenu>
      );
    }
  }

  return (
    <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle nav caret className="text-dark">
        <img className="rounded-circle mr-2" src={currentBrand?.avatar} alt="" width="40px" />
        {currentBrand ? currentBrand?.name : 'Marcas'}
      </DropdownToggle>
      {renderDropDownMenu()}
    </Dropdown>
  );
};
